export default __webpack_public_path__ + "static/media/svg-4.d0b3c47b.svg";